import { notifyError, notifyInfo } from '~/components/common/ToastMessages';

export const handleKlaviyoSubscription = async (email, t) => {
	const listId = __BW_ENV__.REACT_APP_KLAVIYO_ESHOP_NEWSLETTER_LIST_ID;

	if (!email || !listId) {
		notifyError(t('subscription_error'));
		return false;
	}

	try {
		const form = new FormData();
		form.append('g', listId);
		form.append('email', email);
		const res = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
			method: 'POST',
			body: form
		});

		if (!res.ok) {
			console.log('[newsletter] failed:', res.status, await res.text());
			notifyError(t('subscription_error'));
			return false;
		}

		notifyInfo(t('subscribed_to_newsletter'));
		return true;
	} catch (err) {
		console.log('[newsletter] exception:', err);
		notifyError(t('subscription_error'));
		return false;
	}
};
